import React from 'react';
import { useNavigate } from 'react-router-dom';

function ReportsHub() {
  const navigate = useNavigate();

  return (
    <div className="admin-dashboard-container">
      {/* Header with Back Button */}
      <div className="admin-hub-header">
        <button
          onClick={() => navigate('/admin')}
          className="admin-hub-back-btn"
        >
          <span className="admin-hub-back-arrow">←</span>
          Back to Dashboard
        </button>
        <h1 className="admin-page-title">Reports</h1>
        <p className="admin-hub-subtitle">Financial reports and tax documentation</p>
      </div>

      {/* Hub Cards Grid */}
      <div className="admin-hub-grid">
        <div className="card admin-menu-card" onClick={() => navigate('/admin/reports')}>
          <div className="admin-hub-card-icon">📊</div>
          <h2>Financial Reports</h2>
          <p>Revenue analytics, tax escrow tracking, HOA fee management, and comprehensive financial dashboards.</p>
          <button className="btn btn-primary">View Reports</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/tax-summary')}>
          <div className="admin-hub-card-icon">💼</div>
          <h2>Income Tax Summary</h2>
          <p>Annual tax report with quarterly breakdown. Export data for your CPA and track deductible expenses.</p>
          <button className="btn btn-primary">View Tax Report</button>
        </div>
      </div>
    </div>
  );
}

export default ReportsHub;
